// disclosureText — what of the catalogue's document text is fit to SHOW.
//
// The seeded catalogue's EFL/TOS/YRAC fields carry developer scaffolding in
// the prose itself: "Placeholder EFL preview; replace with publisher-approved
// EFL (PUCT §25.475).", "Atlantex Power Terms of Service — placeholder.".
// Printing those sentences to a shopper reads as a broken page.
//
// These helpers strip the scaffolding and keep only the GENUINE catalogue
// prose (a plan's real description survives; a sentence that talks about
// placeholders does not). They never ADD content — a §25.475 document cannot
// be fabricated here, which is why the caller falls back to an honest "comes
// with your contract" line when nothing genuine remains.

const PLACEHOLDER_MARK = /placeholder/iu;

/**
 * Drop every sentence that talks about placeholders; keep the rest verbatim.
 *
 * Sentence-wise, not word-wise: the scaffolding arrives as whole appended
 * sentences, and removing only the word would leave gibberish around it.
 */
export function stripPlaceholderSentences(text: string): string {
  return text
    .split(/(?<=[.!?])\s+/u)
    .filter((sentence) => !PLACEHOLDER_MARK.test(sentence))
    .join(' ')
    .trim();
}

/**
 * The text worth rendering, or null when nothing genuine remains.
 *
 * Null tells the caller to show its honest fallback — never the scaffolding,
 * and never invented document text.
 */
export function presentableDisclosureText(text: string): string | null {
  const cleaned = stripPlaceholderSentences(text);
  return cleaned.length > 0 ? cleaned : null;
}
